import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';

import { TableColumnSortEnum } from '../enums/TableColumnSortEnum';

export function getSortIcon<T>(columns: ITableColumn<T>[], id: keyof T): string {
  const sort = columns.find(item => item.id === id)?.sort || TableColumnSortEnum.NONE;

  if (sort === TableColumnSortEnum.ASC) {
    return '\xa0↑';
  }
  if (sort === TableColumnSortEnum.DESC) {
    return '\xa0↓';
  }

  return TableColumnSortEnum.NONE;
}
